export const BASE_URL = `https://controller.cloud.danea.it`;

export const BUCKET_NAME = `daneabox`;
export const REGION = `eu-central-1`;

export const BUCKET_URL = `https://s3-${REGION}.amazonaws.com/${BUCKET_NAME}/`;
